import { Grid, Tooltip } from '@mui/material';
import React from 'react'
import { DeleteConfirmation } from '../../../../../../../common/DeleteConfirmation';
import { infoToastify } from '../../../../../../../util/toast';

function DeleteItems(props) {
    const { selectedItems, handleRefresh, isGlobal,
        actions: {
            deleteFeeScheduleItems,
            setSelected
        }
    } = props;

    const getFilterPayload = () => {
        const search = window.location.search;
        const rateId = new URLSearchParams(search).get('rateId');

        const finalFilters = rateId
            ? {
                  operands: [
                      ...(props.filters?.operands || []),
                      {
                          operator: "and",
                          filters: [
                              { id: "id", equator: "equals", value: rateId },
                          ],
                      },
                  ],
              }
            : (props.filters?.length > 0 ? props.filters : null);

        return {
            feeScheduleId: props.feeScheduleId,
            inputRequest: {
                page: props.page,
                filter: finalFilters || null,
                sort: props.sort || []
            }
        };
    };

    const handleFeScheduleItemsDelete = (processAll) => {
        const payload = processAll 
            ? {
                isProcessAll: true,
                filterPayload: getFilterPayload()
            }
            : {
                isProcessAll: false,
                ids: props.selectedItems
            };

        deleteFeeScheduleItems(payload,() =>handleCallBack(processAll));
    }

    const handleCallBack = (showToaster=false) => {
        setSelected([]);
        if (showToaster) {
            infoToastify("FeeSchedule rate deletion in progress. You will be notified once it is complete.");
        }
        handleRefresh();
    }

    const pageName = isGlobal ? 'global-feeschedule-items-landing' : 'feeschedule-items-landing';

    return (
        <Grid item>
            <Tooltip title="Delete Fee Schedule Rate">
                <DeleteConfirmation 
                    isAllowedToDelete={(selectedItems.length === 0) ? false : true} 
                    handleDelete={handleFeScheduleItemsDelete} 
                    buttonColor={'default'} 
                    iconSize={'small'} 
                    pageName={pageName}
                    isPending={props.deletePending}
                />
            </Tooltip>
        </Grid>
    )
}

export default DeleteItems
